import React from 'react';
import { Award, Shield, Sparkles, Target } from 'lucide-react';
import { Card } from './ui/card';
import { scellantServices } from '../data/mock';

const iconMap = {
  Award: Award,
  Shield: Shield,
  Sparkles: Sparkles,
  Target: Target
};

const ScellantServices = () => {
  return (
    <section id="scellant-services" className="py-24 bg-black">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            <span className="text-white">Pourquoi choisir notre</span>
            <br />
            <span className="bg-gradient-to-r from-red-600 to-red-500 bg-clip-text text-transparent">
              méthode par pulvérisation
            </span>
          </h2>
          <p className="text-xl text-gray-400 leading-relaxed">
            Contrairement à l'application manuelle, notre méthode par spray permet
            au bitume de respirer et de se régénérer. Résultat : une entrée propre,
            uniforme, durable et visuellement comme neuve.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {scellantServices.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card
                key={service.id}
                className="group relative overflow-hidden hover:shadow-2xl hover:shadow-red-500/20 transition-all duration-300 hover:-translate-y-2 border border-red-500/20 bg-gray-900 p-8 text-center"
              >
                {/* Icon */}
                <div className="mb-6 flex justify-center">
                  <div className="bg-gradient-to-br from-red-600 to-red-500 rounded-full p-5 group-hover:scale-110 transition-transform shadow-lg">
                    <IconComponent className="text-white" size={36} />
                  </div>
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-white mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed">
                  {service.description}
                </p>

                {/* Hover Accent */}
                <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-red-600 to-red-500 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></div>
              </Card>
            );
          })}
        </div>

        {/* Key Advantage Box */}
        <div className="max-w-4xl mx-auto bg-gray-900 border border-red-500/20 rounded-2xl p-12 text-center shadow-2xl">
          <h3 className="text-3xl font-bold text-white mb-4">
            La différence Vision Opale
          </h3>
          <p className="text-xl text-gray-300 mb-6 leading-relaxed">
            Notre équipe de jeunes professionnels allie dynamisme et minutie.
            Chaque projet est traité avec le souci du détail et l'expertise
            nécessaire pour un résultat impeccable et durable.
          </p>
          <div className="flex flex-wrap justify-center gap-6 text-white">
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-red-500 rounded-full"></div>
              <span className="font-semibold">Application uniforme</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-red-500 rounded-full"></div>
              <span className="font-semibold">Matériaux premium</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-red-500 rounded-full"></div>
              <span className="font-semibold">Résultat garanti</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ScellantServices;
